<template>
  <el-dialog
    :title="modifyObj.type===1?'修改密码':'修改手机号'"
    width="40%"
    :before-close="handleClose"
    :visible.sync="isOpen"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" label-width="100px" :rules="rules" label-position="left">
      <div v-if="modifyObj.type===1">
        <el-form-item label="原密码" prop="old_password">
          <el-input v-model="form.old_password" type="password" placeholder="请输入原密码" size="medium" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入8-16位新密码" size="medium" show-password />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirm_password">
          <el-input v-model="form.confirm_password" type="password" placeholder="请再次输入新密码" size="medium" show-password />
        </el-form-item>
      </div>
      <div v-else-if="active===1&&modifyObj.type===2">
        <el-form-item label="原手机号" prop="phone">
          <el-input v-model="form.phone" disabled size="medium" />
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-row style="display:flex;align-items: center;">
            <el-col :span="17" style="padding-right: 16px;">
              <el-input v-model="form.code" placeholder="请输入验证码" size="medium" />
            </el-col>
            <el-col :span="7" style="text-align: right;">
              <el-button :class="authCodeText==='获取验证码'?'code':'code2'" size="medium" @click="getAuthCode">{{ authCodeText }}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="新手机号" prop="newPhone">
          <el-input v-model="form.newPhone" size="medium" />
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-row style="display:flex;align-items: center;">
            <el-col :span="17" style="padding-right: 16px;">
              <el-input v-model="form.code" placeholder="请输入验证码" size="medium" />
            </el-col>
            <el-col :span="7" style="text-align: right;">
              <el-button :class="authCodeText==='获取验证码'?'code':'code2'" size="medium" @click="getAuthCode">{{ authCodeText }}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel" @click="handleClose">取 消</el-button>
      <el-button v-if="modifyObj.type===1||active===2" class="sure" type="primary" @click="sure">确 定</el-button>
      <el-button v-else class="sure" type="primary" @click="next">下一步</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { checkModbile, checkPwd } from '@/utils/validate'
import { modifyPassword, modifyMobile, sendCode } from '@/http/index'
var result = null;
export default {
  props: {
    modifyObj: {
      type: Object,
      default() { return {} }
    }
  },
  data() {
    var checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入新密码'))
      }
      setTimeout(() => {
        if (checkPwd(value)) {
          this.$refs.form.validateField("confirm_password");
          callback()
        } else {
          callback(new Error('请输入8-16位密码，必须包含数字、字母'))
        }
      }, 100)
    };
    var checkPassword2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请再次输入新密码'))
      }
      setTimeout(() => {
        if (value !== this.form.password) {
          callback(new Error('两次密码输入不一致'))
        } else {
          callback()
        }
      }, 100)
    };
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (checkModbile(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    };
    return {
      authCodeText: '获取验证码',
      active: 1,
      form: {},
      timer: true,
      code: null,
      rules: {
        old_password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: checkPassword, trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, validator: checkPassword2, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        newPhone: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.modifyObj.modifyVisible;
      },
      set(val) {
        this.$emit("update:modifyObj", val);
      }
    }
  },
  watch: {
    'modifyObj': { // $route可以用引号，也可以不用引号  监听的对象
      handler(val) {
        this.form.mobile = val.mobile;
        this.form.phone = val.phone;
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true // 第一次初始化渲染就可以监听到
    }
  },
  methods: {
    getAuthCode() {
      if (!this.timer) return false
      if (!checkModbile(this.active === 2 ? this.form.newPhone : this.form.mobile)) return this.$message.error('请输入正确的手机号码')
      this.sendCode();
    },
    async sendCode() {
      const res = await sendCode({ mobile: this.active === 2 ? this.form.newPhone : this.form.mobile })
      if (res.code === 200) {
        let num = 60
        this.code = res.data[0]
        this.authCodeText = num + '后重新获取'
        result = setInterval((_) => {
          if (num <= 0) {
            this.authCodeText = '获取验证码'
            this.timer = true;
            clearInterval(result)
          } else {
            num--;
            this.authCodeText = num + 's重新获取'
            this.timer = false
          }
        }, 1000);
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.form = {};
      this.isOpen = false;
      this.active = 1;
      this.code = null;
      this.authCodeText = '获取验证码'
      this.timer = true;
      clearInterval(result)
    },
    updateInfo() {
      this.handleClose();
      this.$emit('updateInfo')
    },
    sure() {
      this.$refs['form'].validate(async(valid) => {
        if (valid) {
          if (this.modifyObj.type === 1) {
            // 修改密码
            const res = await modifyPassword({
              token: localStorage.getItem('token'),
              secret: localStorage.getItem('secret'),
              hospital_id: localStorage.getItem('hospital_id'),
              password: this.$md5(this.form.password),
              confirm_password: this.$md5(this.form.confirm_password),
              old_password: this.$md5(this.form.old_password)
            });
            if (res.code === 200) {
              this.form = {}
              this.$message.success('修改成功');
              this.updateInfo();
            }
          } else {
            const res = await modifyMobile({
              token: localStorage.getItem('token'),
              secret: localStorage.getItem('secret'),
              hospital_id: localStorage.getItem('hospital_id'),
              mobile: this.form.newPhone,
              code: this.form.code
            });
            if (res.code === 200) {
              this.form = {}
              this.$message.success('修改成功');
              this.updateInfo();
            }
          }
        }
      });
    },
    next() {
      this.$refs['form'].validate(async(valid) => {
        if (valid) {
          this.active = 2;
          this.timer = true;
          this.authCodeText = '获取验证码'
          this.form.code = null
          this.code = null;
          clearInterval(result)
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.code{
    width: 100%;
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #DD594A;
    background: #FFFFFF;
    opacity: 1;
    border: 1px solid #EEEEEE;
    line-height: 1;
}
.code2{
    width: 100%;
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #BFBFBF;
    background: #FFFFFF;
    opacity: 1;
    border: 1px solid #EEEEEE;
    line-height: 1;
}
</style>
